import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";

import history from "../../../../../history";
import { checkAgreement, agree, disagree, getReport } from "../../../../../actions/workingTimeActions";

class Report extends React.Component {
    constructor(props) {
        super(props);

        this.month = "";
        this.startMonth = "";
    }

    componentDidMount() {
        if (this.props.userID !== undefined && +this.props.userID === this.props.currentUser.userID) history.push("/working-time/my?month=current");
        else {
            if (this.props.type === "my") this.props.checkAgreement();
            this.updateList();
        }
    }

    componentDidUpdate() {
        if (this.props.userID !== undefined && +this.props.userID === this.props.currentUser.userID) history.push("/working-time/my?month=current");
        else {
            if (this.props.type === "my" && this.props.agreement === null) this.props.checkAgreement();
            this.updateList();
        }
    }

    updateList = () => {
        if (this.props.agreement || this.props.type !== "my") {
            this.queryParams = queryString.parse(history.location.search);
            this.month = this.queryParams.month === "previous" ? "previous" : "current";
            if (this.month !== this.startMonth) {
                this.startMonth = this.month;
                this.props.getReport(this.props.userID, this.month);
            }
        }
    };

    formatValue = value => `${value < 0 ? "-" : ""}${Math.floor(Math.abs(value))}:${Math.round(60 * (Math.abs(value) % 1)) < 10 ? "0" : ""}${Math.round(60 * (Math.abs(value) % 1))}`;

    renderRows = () => this.props.report.details.map((pos, index) => this.renderRow(pos, index));

    renderRow = (row = null, index = null) => {
        return (
            <tr key={row ? index : "header"}>
                <td className={row ? "content" : "header"}>{row ? row.day : "Dzień"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.totalWorkingTime) : "Suma karty pracy"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.availableBreakTime) : "Należna przerwa"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.actualBreakTime) : "Czas przewy"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.overBreakTime) : "Przekroczona przerwa"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.actualWorkingTime) : "Czas pracy"}</td>
                <td className={row ? "content" : "header"}>{row ? this.formatValue(row.overtime) : "Nadgodziny"}</td>
                {/* <td className={row ? `${row.correct === 1 ? "" : "red "}content` : "header"}>{row ? (row.correct === 1 ? "OK" : "Błąd") : "Status"}</td> */}
            </tr>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.props.agreement || this.props.type !== "my" ? (
                    <React.Fragment>
                        <div className={`ui two item menu`}>
                            <Link to={`${history.location.pathname}?month=previous`} className={`${this.month === "previous" ? "active " : ""}item`}>
                                <div className="content">Poprzedni miesiąc</div>
                            </Link>
                            <Link to={`${history.location.pathname}?month=current`} className={`${this.month === "current" ? "active " : ""}item`}>
                                <div className="content">Obecny miesiąc</div>
                            </Link>
                        </div>
                        <div className="ui divider" />
                    </React.Fragment>
                ) : null}
                <div className="ui container">
                    {this.props.agreement !== null || this.props.type !== "my" ?
                        ((this.props.agreement || this.props.type !== "my") && this.props.report.reportID) ? (
                            <React.Fragment>
                                <div className="ui large header">
                                    <div className="content">{`Raport nr ${this.props.report.reportID} za okres od: ${this.props.report.dateFrom} do: ${this.props.report.dateTo}${this.props.type !== "my" ? ` użytkownika ${this.props.report.lname} ${this.props.report.fname}` : ""}`}</div>
                                </div>
                                <table className="header">
                                    <tbody>
                                        <tr>
                                            <td className="header">Norma czasu pracy:</td>
                                            <td className="header">Łączny czas pracy:</td>
                                            <td className="header">Suma nadgodzin:</td>
                                        </tr>
                                        <tr>
                                            <td>{this.props.report.standard}</td>
                                            <td>{this.formatValue(this.props.report.workingTime)}</td>
                                            <td>{this.formatValue(this.props.report.totalOvertime)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="ui divider" />
                                <table className="content">
                                    <tbody>
                                        {this.renderRow()}
                                        {this.renderRows()}
                                    </tbody>
                                </table>
                                <div className="right content">Ostatnio zaktualizowany: <b>{this.props.report.createdOn}</b></div>
                            </React.Fragment>
                        ) : this.props.agreement || this.props.type !== "my" ? (
                            <div className="ui large header">
                                <div className="content">Nie odnaleziono raportu</div>
                            </div>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="clock icon"></i>
                                        <div className="header">Czy chcesz otrzymywać raporty o czasie pracy?</div>
                                        <div className="ui divider" />
                                        <div className="content">
                                            <button className="ui button" type="button" onClick={this.props.agree}>Chcę otrzymywać raporty</button>
                                        </div>
                                    </h2>
                                </div>
                            </div>
                        )
                    : null}
                </div>
                {this.props.agreement || this.props.type !== "my" ? (
                    <React.Fragment>
                        <div className="ui divider" />
                        <div className="footer content">
                            <p>Raport generowany automatycznie, codziennie rano</p>
                        </div>
                    </React.Fragment>
                ) : null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    agreement: state.workingTime.agreement,
    report: state.workingTime.report
});

export default connect(mapStateToProps, { checkAgreement, agree, disagree, getReport })(Report);